module.exports = __webpack_public_path__ + "static/media/JOHNPHILIP.a3e22682.png";